import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './index.css' // Tailwind 样式入口
import 'font-awesome/css/font-awesome.min.css'
import '@/assets/iconfont/iconfont.css'
createApp(App)
  .use(router)
  .mount('#app')